module.exports = __webpack_public_path__ + "static/media/bank.bc852d22.png";